// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-204316b0] .dot {\n  width: 32px !important;\n  height: 32px !important;\n}\n[data-v-204316b0] .custom-radio__extended .col-12 {\n  padding: 0 !important;\n}\n[data-v-204316b0] .ab-btn-success:disabled {\n  background-color: #b5c3bc !important;\n  border-color: #b5c3bc !important;\n}\n.action-button__extended[data-v-204316b0] {\n  margin-top: 1.85rem;\n}", ""]);
// Exports
module.exports = exports;
